import { ensureKeys } from '@/common/react';
import { Flex, FlexProps } from '@mantine/core';
import styles from './footer.module.css';

export type FooterProps = FlexProps;

export const Footer = ({ children, ...props }: FooterProps) => (
	<Flex
		align="center"
		py="0"
		px="xl"
		gap="sm"
		justify="space-between"
		className={styles.root}
		{...props}
	>
		{ensureKeys(children)}
	</Flex>
);
